import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

import SubTitle from "./SubTitle";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";

import { API } from "../../global";

// const data = [
//   { name: "success", value: 20 },
//   { name: "failure", value: 75 }
// ]

const COLORS = {
  Failure: "#ff3738",
  Success: "#00ba88",
};

const TodaysTask = () => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    getTodayPipelineData();
    // eslint-disable-next-line
  }, []);

  const getTodayPipelineData = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("auth_token")}`,
        },
      };

      const response = await axios.get(
        `${API}/dashboard/filter-pipelines?pipeline=All Pipelines&frequency=Today`,
        config
      );

      if (response.data.success) {
        const results = response.data.result;

        const statusCounts = results.reduce((acc, pipeline) => {
          pipeline.pipeline_logs.forEach((log) => {
            if (log.status === "success" || log.status === "failure") {
              acc[log.status] = (acc[log.status] || 0) + 1;
            }
          });
          return acc;
        }, { success: 0, failure: 0 });

        const total = statusCounts.success + statusCounts.failure;

        const formattedData = [
          { name: "Failure", value: total ? (statusCounts.failure / total) * 100 : 0 },
          { name: "Success", value: total ? (statusCounts.success / total) * 100 : 0 },
        ].filter((item) => item.value > 0);

        setChartData(formattedData);
      } else {
        toast.error(response.data.error.msg);
      }
    } catch (error) {
      toast.error("Error fetching today's pipeline data");
    }
  };

  return (
    <div>
      <SubTitle title="Today's Pipeline Statistics" showDropdown={false} />
      {chartData && chartData.length > 0 ? (
        <div className="p-3 min-h-20 h-64 relative flex self-center">
          <div className="absolute top-[3.5em] left-[5.7em] xl:left-[9.7em] text-xl text-center">
            All <br /> Pipelines
          </div>
          <ResponsiveContainer width="100%" height={220} className="text-xs">
            <PieChart
              margin={{ top: -15, right: 0, bottom: 0, left: 0 }}
            >
              <Pie
                data={chartData}
                dataKey="value"
                innerRadius={60}
                outerRadius={90}
                fill="#8884d8"
              >
                <LabelList
                  dataKey="value"
                  position="inside"
                  fill="#fff"
                  formatter={(value) => `${value}%`}
                  style={{ fontWeight: "lighter", fontSize: "10px" }}
                />
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[entry.name]} />
                ))}
              </Pie>
              <Legend layout="horizontal" verticalAlign="bottom" align="center" />
            </PieChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="text-sm font-medium flex items-center justify-center h-64">
          No data available for today.
        </div>
      )}
    </div>
  );
};

export default TodaysTask;